module.exports = __webpack_public_path__ + "img/icon_get.ddfb3514.png";